import { ReactComponent as CarsparencyLogoSvg } from './CarsparencyLogo.svg';
import { ReactComponent as CheckSvg } from './check.svg';
import { ReactComponent as CloseSvg } from './close-line.svg';
import { ReactComponent as CarDefault } from './damage_missing_trims.svg';
import { ReactComponent as DefaultCarSvg } from './Default_car.svg';
import { ReactComponent as EmptyStateSvg } from './empty-pending.svg';
import { ReactComponent as FileSvg } from './file.svg';
import { ReactComponent as GuaranteeSvg } from './garanty.svg';
import { ReactComponent as InfoCircleSvg } from './info-circle.svg';
import { ReactComponent as PlaySvg } from './play.svg';
import { ReactComponent as WarningSvg } from './rect-warning-line.svg';
import { ReactComponent as SearchSvg } from './search.svg';

export {
  CarDefault,
  CarsparencyLogoSvg,
  CheckSvg,
  CloseSvg,
  DefaultCarSvg,
  EmptyStateSvg,
  FileSvg,
  GuaranteeSvg,
  InfoCircleSvg,
  PlaySvg,
  SearchSvg,
  WarningSvg,
};
